/** FDA form-type vocabulary v1.4, retrieved 2026-10-25.
 * Source: https://www.accessdata.fda.gov/static/eCTD/form-type.xml
 * Shared by API validation, compiler metadata, and the manual form selector.
 * Keep dependency-free so the frontend can import the same definition.
 */
export const FDA_FORM_TYPES = [
  { code: "fdaft1", label: "Form FDA 1571: Investigational New Drug Application (IND)", formKey: "fda-form-1571" },
  { code: "fdaft2", label: "Form FDA 356h: Application to Market a New Drug, Biologic, or an Antibiotic Drug for Human Use", formKey: "fda-form-356h" },
  { code: "fdaft3", label: "Form FDA 3397: User Fee Cover Sheet", formKey: "fda-form-3397" },
  { code: "fdaft4", label: "Form FDA 2252: Transmittal of Annual Reports for Drugs and Biologics for Human Use", formKey: "fda-form-2252" },
  { code: "fdaft5", label: "Form FDA 2253: Transmittal of Advertisements and Promotional Labeling for Drugs and Biologics for Human Use", formKey: "fda-form-2253" },
  { code: "fdaft6", label: "Form FDA 2567: Transmittal of Labels and Circulars", formKey: "fda-form-2567" },
  { code: "fdaft7", label: "Form FDA 3674: Certification of Compliance", formKey: "fda-form-3674" },
  { code: "fdaft8", label: "Form FDA 3792: Biosimilar User Fee Cover Sheet (BsUFA)", formKey: "fda-form-3792" },
  { code: "fdaft9", label: "Form FDA 3794: Generic Drug User Fee Cover Sheet (GDUFA)", formKey: "fda-form-3794" },
  { code: "fdaft10", label: "Form FDA 3988: Transmittal of PMR/PMC Submissions for Drugs and Biologics", formKey: "fda-form-3988" },
  { code: "fdaft11", label: "Form FDA 3938: Drug Master File", formKey: "fda-form-3938" },
 ] as const;

export type FdaFormType = (typeof FDA_FORM_TYPES)[number]['code'];
export const FDA_FORM_KEY_CODES: Readonly<Record<string, FdaFormType>> = Object.freeze(
  Object.fromEntries(FDA_FORM_TYPES.map(form => [form.formKey, form.code])) as Record<string, FdaFormType>,
);
const VALID_CODES: ReadonlySet<string> = new Set(FDA_FORM_TYPES.map(form => form.code));
export function isFdaFormType(value: unknown): value is FdaFormType {
  return typeof value === 'string' && VALID_CODES.has(value);
}
export function fdaFormTypeForGovernmentFormKey(key: string | null | undefined): FdaFormType | undefined {
  return key && Object.hasOwn(FDA_FORM_KEY_CODES, key) ? FDA_FORM_KEY_CODES[key] : undefined;
}
